import { useEffect, useState } from "react";
import "./App.css";
import axios from "axios";
import Header from "./components/sections/Header";
import Hero from "./components/sections/Hero";
import Selected from "./components/sections/Selected";
import About from "./components/sections/About";
import Documentaries from "./components/sections/Documentaries";
import Journalism from "./components/sections/Journalism";
import Radio from "./components/sections/Radio";
import VisualDiaries from "./components/sections/VisualDiaries";
import PhotoEssays from "./components/sections/PhotoEssays";
import Contact from "./components/sections/Contact";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/portfolio`)
      .then((res) => {
        if (active) setData(res.data);
      })
      .catch((e) => {
        console.error("Failed to load portfolio", e);
        if (active) setError(e.message);
      });
    return () => {
      active = false;
    };
  }, []);

  // Reveal on scroll: simple IO for any .reveal not yet activated
  useEffect(() => {
    if (!data) return;
    const els = document.querySelectorAll(".reveal:not(.in)");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [data]);

  if (!data) {
    return (
      <div className="App min-h-screen flex items-center justify-center bg-[#0D0D0D] text-[#EAEAEA]" data-testid="loading-state">
        <div className="text-center">
          <div className="font-mono-overline text-[#C4A27A] mb-4">Loading</div>
          <div className="font-serif-display text-3xl">Nadeer Hashmi</div>
          {error && (
            <div className="mt-6 text-red-400 text-sm" data-testid="loading-error">
              {error}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero profile={data.profile} />
        <Selected
          video={data.documentaries.find((v) => v.id === "d1")}
          article={data.articles[0]}
          photo={data.photos[0]}
        />
        <About profile={data.profile} />
        <Documentaries items={data.documentaries.filter((v) => v.category !== "visual")} />
        <Journalism items={data.articles} />
        <Radio items={data.radio} />
        <VisualDiaries items={data.documentaries.filter((v) => v.category === "visual")} />
        <PhotoEssays items={data.photos} />
        <Contact profile={data.profile} />
      </main>
    </div>
  );
}

export default App;
